package cc.bluepeak.clubmanager.site.components.widgets

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.styles.Theme
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCircleCheckBig
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em

@Composable
fun Checkmark(text: String, color: CSSColorValue = Theme.primary) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(.5.cssRem)
    ) {
        LucideCircleCheckBig(color = color, size = 1.5.em)
        SpanText(text)
    }
}